import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/tokens.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function bootstrap() {
  const mimirBaseUrl = process.env.REACT_APP_MIMIR_BASE_URL
    || (process.env.NODE_ENV === "development" ? "http://localhost:8087" : "");
  if (!mimirBaseUrl) throw new Error("REACT_APP_MIMIR_BASE_URL deve apontar para o Mimir neste ambiente.");
  const environment = process.env.REACT_APP_CONFIG_ENVIRONMENT || "local";
  const response = await fetch(`${mimirBaseUrl}/public/services/novaagenda/runtime-config?environment=${encodeURIComponent(environment)}`);
  if (!response.ok) throw new Error(`Mimir respondeu ${response.status} ao carregar a configuração do frontend.`);
  const payload = await response.json();
  window.__MIMIR_CONFIG__ = payload.variables || {};
  const [{ default: App }, { I18nProvider }] = await Promise.all([
    import("./App"),
    import("./i18n/I18nContext"),
  ]);
  root.render(<I18nProvider><App /></I18nProvider>);
}

bootstrap().catch(() => {
  root.render(<main style={{ padding: 24 }}><h1>Configuração indisponível</h1><p>Não foi possível carregar as configurações do Mimir.</p></main>);
});
